import { render } from "./main.vue?vue&type=template&id=123bc54d&ts=true"
import script from "./main.ts?vue&type=script&lang=ts"
export * from "./main.ts?vue&type=script&lang=ts"

import exportComponent from "C:\\Repos\\Sinter\\SinterAdmin\\src\\sa-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__